import DoHlsVideo from './DoHlsVideo';

/* istanbul ignore next */
DoHlsVideo.install = function (Vue) {
    Vue.component(DoHlsVideo.name, DoHlsVideo);
};

export default DoHlsVideo;